module.exports = __webpack_public_path__ + "static/self-design-3-46244a249a2cb162579a8866f4cc2472.png";